import { COST_SIMULATION_YEARS, pickT } from "@repo/shared";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { T } from "./settings-cost-table-form.i18n";

type SettingsCostTableFormProps = {
  flowLanguage: string;
  showHoldingPeriod: boolean;
  onShowHoldingPeriodChange: (show: boolean) => void;
  holdingPeriodYears: number;
  onHoldingPeriodYearsChange: (years: number) => void;
};

export function SettingsCostTableForm({
  flowLanguage,
  showHoldingPeriod,
  onShowHoldingPeriodChange,
  holdingPeriodYears,
  onHoldingPeriodYearsChange,
}: SettingsCostTableFormProps) {
  const t = pickT(T, flowLanguage);

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <div>
          <Label htmlFor="cost-table-show-holding-period" className="text-base">
            {t.showHoldingPeriod}
          </Label>
          <p className="text-sm text-muted-foreground">{t.showHoldingPeriodDesc}</p>
        </div>
        <Switch
          id="cost-table-show-holding-period"
          checked={showHoldingPeriod}
          onCheckedChange={onShowHoldingPeriodChange}
        />
      </div>

      {showHoldingPeriod && (
        <div className="space-y-2">
          <Label htmlFor="cost-table-holding-period-years">{t.holdingPeriodYears}</Label>
          <Input
            id="cost-table-holding-period-years"
            type="number"
            min={2}
            max={COST_SIMULATION_YEARS}
            value={holdingPeriodYears}
            onChange={(e) => onHoldingPeriodYearsChange(Number(e.target.value))}
          />
          <p className="text-xs text-muted-foreground">{t.holdingPeriodYearsDesc}</p>
        </div>
      )}
    </div>
  );
}
